import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import PlaySubSequenceNodePreview from "../../features/sequence/node_previews/PlaySubSequenceNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import { compactSearchableStrings } from "./SearchableInteractionValues";

export interface IPlaySubSequence extends Interaction {
  nodeToPlay: string;
}

export const playSubSequenceInteraction = (): InteractionFactoryEntity => {
  const create = (getKeys: (amount: number) => string[]): IPlaySubSequence => {
    return {
      id: GetNewGuid(),
      name: "Play Sub Sequence",
      type: InteractionType.PlaySubSequence,
      nodeToPlay: "",
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IPlaySubSequence => {
    return interaction as IPlaySubSequence;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[]
  ): IPlaySubSequence => {
    const original = interaction as IPlaySubSequence;

    return {
      ...original,
      id: GetNewGuid(),
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string
  ): string[] => {
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    const converted = interaction as IPlaySubSequence;
    return getMatchingResults(
      compactSearchableStrings(interaction.name, converted.nodeToPlay),
      takeName,
      interaction,
      "Play Sub Sequence"
    );
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[]
  ): string[] => {
    return [];
  };

  return {
    View: <></>,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <PlaySubSequenceNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
    FilterType: "Play Sub Sequence",
  };
};
